"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.toISOString = exports.setTimeInDate = exports.processDateUTC = exports.processDate = exports.offsetTimezone = exports.isMaxDate = exports.getYearFromDate = exports.getUTCOffset = exports.getLastDayOfTheYear = exports.getEndOfDay = exports.formatUTCByGivenDate = exports.formatTimeDigit = exports.extractTimeFromDate = exports.dateDaysDiff = exports.addDays = exports.MAX_DATE = void 0;
var R = _interopRequireWildcard(require("ramda"));
var _dateFns = require("date-fns");
var _config = _interopRequireDefault(require("@trs/config"));
var _objects = require("../objects");
var _helpers = _interopRequireDefault(require("./helpers"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var DATE_FORMAT = _config["default"].DATE_FORMAT;
var MERIDIEM_TYPE = {
  AM: 'AM',
  PM: 'PM'
};
var MAX_DATE = exports.MAX_DATE = '9999-12-31T23:59:59.9999999';
var formatTimeDigit = exports.formatTimeDigit = function formatTimeDigit(hour) {
  return hour < 10 ? "0".concat(hour) : hour;
};
var formatUTC = function formatUTC(date, dateFormat, withOffset) {
  var currentOffset = date.getTimezoneOffset() > 0 ? date.getTimezoneOffset() : 0;
  var offset = withOffset ? date.getTimezoneOffset() : currentOffset;
  var dateOnly = new Date(date.valueOf() + offset * 60 * 1000);
  return (0, _dateFns.format)(dateOnly, dateFormat);
};
var formatUTCByGivenDate = exports.formatUTCByGivenDate = function formatUTCByGivenDate(date, dateFormat) {
  var originalDate = new Date(date);
  var modifiedDate = new Date(originalDate.valueOf() + originalDate.getTimezoneOffset() * 60 * 1000);
  return (0, _dateFns.format)(modifiedDate, dateFormat);
};
var processDate = exports.processDate = function processDate(date) {
  var dateFormat = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DATE_FORMAT;
  var offset = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
  var dateObject = new Date(date);
  if ((0, _objects.isBlank)(date) || !dateObject.valueOf()) return '';
  return formatUTC(dateObject, dateFormat, dateFormat !== DATE_FORMAT && offset);
};
var processDateUTC = exports.processDateUTC = function processDateUTC(date) {
  var withSeconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  if ((0, _objects.isBlank)(date)) return '';
  var dateObject = new Date(date);
  var processedDate = processDate(date);
  var hours = formatTimeDigit(dateObject.getUTCHours());
  var minutes = formatTimeDigit(dateObject.getUTCMinutes());
  var seconds = formatTimeDigit(dateObject.getUTCSeconds());
  var secondsLabel = ":".concat(seconds);
  return "".concat(processedDate, " ").concat(hours, ":").concat(minutes).concat(withSeconds ? secondsLabel : '');
};
var offsetTimezone = exports.offsetTimezone = function offsetTimezone(date) {
  var temp = date ? new Date(date) : new Date(new Date().setHours(0, 0, 0, 0));
  temp.setTime(temp.getTime() - temp.getTimezoneOffset() * 60000);
  return temp.toISOString();
};
var getLastDayOfTheYear = exports.getLastDayOfTheYear = function getLastDayOfTheYear() {
  return new Date(new Date().getFullYear(), 11, 31);
};
var addDays = exports.addDays = function addDays(date, days) {
  if (!date || !days && days !== 0) return null;
  var result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
};
var getYearFromDate = exports.getYearFromDate = function getYearFromDate(date) {
  return date ? new Date(date).getFullYear() : new Date().getFullYear();
};
var isMaxDate = exports.isMaxDate = function isMaxDate() {
  var date = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return date.toString().includes('9999');
};

/*
  getTimezoneOffset returns the opposite sign that is used for UTC, thus we set the - in front of date
  e.g. for UTC+3 Romania time, getTimezoneOffset returns - and we need +
*/
var getUTCOffset = exports.getUTCOffset = function getUTCOffset(date) {
  return -date.getTimezoneOffset() / 60;
};
var toISOString = exports.toISOString = function toISOString(date) {
  return new Date(date).toISOString();
};
var dateDaysDiff = exports.dateDaysDiff = function dateDaysDiff(dateLeft, dateRight) {
  return Math.round(Math.ceil((0, _dateFns.differenceInMilliseconds)(new Date(dateLeft), new Date(dateRight)) / (24 * 60 * 60 * 1000)));
};
var setTimeInDate = exports.setTimeInDate = function setTimeInDate(date, time) {
  if (!date) return '';
  var timeObject = (0, _helpers["default"])(time);
  var hours = timeObject.hours;
  var minutes = timeObject.minutes,
    meridiem = timeObject.meridiem;
  if (R.has(meridiem, MERIDIEM_TYPE)) {
    if (meridiem === MERIDIEM_TYPE.PM && hours !== '12') {
      hours = (parseInt(hours, 10) + 12).toString();
    } else if (meridiem === MERIDIEM_TYPE.AM && hours === '12') {
      hours -= 12;
    }
  }
  date.setHours(hours || 0);
  date.setMinutes(minutes || 0);
  return date;
};
var extractTimeFromDate = exports.extractTimeFromDate = function extractTimeFromDate(date) {
  if ((0, _objects.isBlank)(date)) return null;
  var hh = formatTimeDigit(date.getHours());
  var mm = formatTimeDigit(date.getMinutes());
  return {
    hours: hh,
    minutes: mm,
    label: "".concat(hh, ":").concat(mm)
  };
};
var getEndOfDay = exports.getEndOfDay = function getEndOfDay(date) {
  var temp = new Date(new Date(date).setHours(23, 59, 59, 999));
  return temp.toISOString();
};